import {createStore} from 'vuex'
import preConsultation from './pre-consultation'
import selfDiagnosis from './self-diagnosis'
import healthEncyclopedia from './health-encyclopedia'
import AIAssistant from './AI-assistant'
import DemoPlay from './DemoPlay'
import hospitalKnowledgeHandbook from './hospital-knowledge-handbook'
import layout from './layout'
import keepAlive from './keep-alive'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    // 预问诊 store
    preConsultation,
    // 智能自珍 store
    selfDiagnosis,
    // 健康百科
    healthEncyclopedia,
    // AI小助手
    AIAssistant,
    // 演示播放
    DemoPlay,
    // 院内知识手册
    hospitalKnowledgeHandbook,
    // 就医助手Layout
    layout,
    // 缓存列表
    keepAlive
  }
})
